import { render, staticRenderFns } from "./CompactItem.vue?vue&type=template&id=64419ee0&scoped=true&"
import script from "./CompactItem.vue?vue&type=script&lang=js&"
export * from "./CompactItem.vue?vue&type=script&lang=js&"
import style0 from "./CompactItem.vue?vue&type=style&index=0&id=64419ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64419ee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
